import { plural } from "../../design/format/numbers.ts";

export const stockRuleCopy = {
  alerta: (produto: string, unidades: string, limite: string, anuncios: number) =>
    `${produto} tem ${unidades} em estoque, e o limite é ${limite}: ` +
    `${anuncios} ${plural(anuncios, "anúncio ativo vende", "anúncios ativos vendem")} esse produto.`,
  proximo: "A Nabla propõe a pausa na próxima rodada; com o estoque reposto, o alerta fecha na próxima leitura da loja.",
  noLimite: (limite: number) => `No limite de ${limite} ou abaixo: a Nabla propõe pausar este anúncio na próxima rodada.`,
  regras: { "estoque-minimo": { unidade: "unidades" } },
} as const;
